export let roomMessageFuncArr = []
export let roomControlFuncArr = []

export function pushRoomMessageFunc(callBack) {
  if (typeof callBack == 'function') {
    roomMessageFuncArr.push(callBack)
  }
}
export function pushRoomControlFunc(callBack) {
  if (typeof callBack == 'function') {
    roomControlFuncArr.push(callBack)
  }
}

export function getRoomMessageFunc(msg) {
  roomMessageFuncArr.forEach(callBack => {
    if (!callBack) return
    callBack(msg)
  })
}
export function gethRoomControlFunc(msg) {
  roomControlFuncArr.forEach(callBack => {
    //console.log("gethRoomControlFunc")
    if (!callBack) return
    callBack(msg)
  })
}

export function removeMessageFunc(fn) {
  roomMessageFuncArr = roomMessageFuncArr.filter(v => v !== fn)
  roomControlFuncArr = roomControlFuncArr.filter(v => v !== fn)
}